export default {
  namespaced: true,
  state: {
    transcriptions: [],
    recognitionLanguages: {},
    selfRecognitionLanguage: "en-US",
    voiceDialects: [],
    textDialects: [],
    transcribing: false,
    transcriptionResultJsonIds: [],
  },
  getters: {
    transcriptions: (state) => state.transcriptions,
    selfRecognitionLanguage: (state) => state.selfRecognitionLanguage,
    recognitionLanguages: (state) => state.recognitionLanguages,
    voiceDialects: (state) => state.voiceDialects,
    textDialects: state => state.textDialects,
    transcribing: (state) => state.transcribing,
    transcriptionResultJsonIds: (state) => state.transcriptionResultJsonIds,
  },
  mutations: {
    initTranscriptions(state) {
      state.transcriptions = [];
      state.transcriptionResultIds = [];
    },
    setTranscriptions(state, transcriptions) {
      state.transcriptions = [...transcriptions];
    },
    addTranscription(state, transcription) {
      state.transcriptions = [...state.transcriptions, transcription];
    },
    insertTranscription(state, data) {
      const { insertIndex, transcription } = data;
      state.transcriptions.splice(insertIndex, 1, transcription);
    },
    setSelfRecognitionLanguage(state, value) {
      state.selfRecognitionLanguage = value;
    },
    setRecognitionLanguages(state, options) {
      state.recognitionLanguages = {...state.recognitionLanguages, ...options};
    },
    setDialects(state, dialects) {
      const getOrderdedDialects = (dialects) => {
        const originDialects = [...dialects];
        const engOptionIndex = originDialects.findIndex(option => option.code === "en");
        const engOption = engOptionIndex >= 0 ? {...originDialects[engOptionIndex]} : null;
        if (engOptionIndex >= 0) {
          originDialects.splice(engOptionIndex, 1);
        }
        const esOptionIndex = originDialects.findIndex(option => option.code === "es");
        const esOption = esOptionIndex >= 0 ? {...originDialects[esOptionIndex]} : null;
        if (esOptionIndex >= 0) {
          originDialects.splice(esOptionIndex, 1);
        }
        return [engOption, esOption, ...originDialects];
      };
      const { voiceDialects, textDialects } = dialects;
      if (voiceDialects) {
        state.voiceDialects = getOrderdedDialects(voiceDialects);
      }
      if (textDialects) {
        state.textDialects = getOrderdedDialects(textDialects);
      }
    },
    setTranscribing(state, value) {
      state.transcribing = value;
    },
    addTranscriptionResultJsonId(state, resultJsonId) {
      if (!state.transcriptionResultJsonIds.includes(resultJsonId)) {
        state.transcriptionResultJsonIds.push(resultJsonId);
      }
    }
  },
};